import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShoppingCart } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-[#F5F1E8] relative overflow-hidden" data-id="element-254">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 pointer-events-none" data-id="element-255" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-256">
        <div className="text-center mb-12" data-id="element-257">
          <span className="bg-[#1a3a52] text-[#C9A961] px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wider mb-6 inline-block" data-id="element-258">
            Oferta de Lanzamiento - Tiempo Limitado
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a3a52] mb-6" data-id="element-259">
            Compra COMUNICACIÓN MAGNÉTICA y llévate 6 ebooks de regalo
          </h2>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-lg text-gray-600 font-medium" data-id="element-260">
            <p className="flex items-center gap-2" data-id="element-261">
              <span className="w-2 h-2 bg-[#C9A961] rounded-full" data-id="element-262" />
              Promoción por tiempo limitado
            </p>
            <p className="flex items-center gap-2" data-id="element-263">
              <span className="w-2 h-2 bg-[#C9A961] rounded-full" data-id="element-264" />
              Acceso: Descarga digital inmediata
            </p>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-[#C9A961] overflow-hidden relative" data-id="element-265">
          {/* Header of Card */}
          <div className="bg-[#1a3a52] p-6 text-center relative overflow-hidden" data-id="element-266">
            <div className="absolute top-0 left-0 w-full h-full bg-[#C9A961]/10" data-id="element-267" />
            <h3 className="text-2xl font-bold text-white relative z-10" data-id="element-268">
              Pack Comunicación Magnética - Edición Premium
            </h3>
            <p className="text-[#C9A961] relative z-10" data-id="element-269">
              7 Ebooks · Acceso de por vida + Actualizaciones
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-270">
            <div className="flex flex-col md:flex-row justify-between items-center mb-10 gap-8" data-id="element-271">
              <div className="flex-1 w-full" data-id="element-272">
                <ul className="space-y-4" data-id="element-273">
                  {['Libro digital: Comunicación Magnética', 'BONO 1: Tu Aura Digital', 'BONO 2: Lenguaje Corporal de Poder', 'BONO 3: Máster de la Voz', 'BONO 4: Historias Magnéticas', 'BONO 5: Domina el Escenario', 'BONO 6: Arma tu Home Studio Pro'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-274">
                      <div className="bg-[#E6F4EA] p-1 rounded-full text-green-600 flex-shrink-0" data-id="element-275">
                        <Check size={16} strokeWidth={3} data-id="element-276" />
                      </div>
                      <span className="font-medium" data-id="element-277">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex-shrink-0 text-center bg-[#F5F1E8] p-8 rounded-2xl border border-[#C9A961]/30 w-full md:w-auto" data-id="element-278">
                <p className="text-gray-500 line-through text-lg font-medium mb-1" data-id="element-279">
                  Valor Total: $250.00
                </p>
                <div className="flex items-center justify-center gap-2 mb-2" data-id="element-280">
                  <span className="text-5xl font-bold text-[#1a3a52]" data-id="element-281">
                    $9.95
                  </span>
                  <span className="text-xl text-gray-500 font-medium" data-id="element-282">USD</span>
                </div>
                <div className="bg-[#C9A961] text-[#1a3a52] text-xs font-bold px-3 py-1 rounded-full inline-block mb-4" data-id="element-283">
                  AHORRA MÁS DE $240 HOY
                </div>
                <p className="text-sm text-gray-600 font-medium" data-id="element-284">
                  Precio especial de lanzamiento
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-285">
              <motion.a href="https://mikioscodigital.com/cart/51802866975001:1" whileHover={{
              scale: 1.05,
              rotateY: 5,
              boxShadow: '0 0 60px rgba(255, 215, 0, 0.8), 0 0 100px rgba(255, 165, 0, 0.6)'
            }} whileTap={{
              scale: 0.95
            }} animate={{
              boxShadow: ['0 0 40px rgba(255, 215, 0, 0.6), 0 0 80px rgba(255, 165, 0, 0.4)', '0 0 60px rgba(255, 215, 0, 0.8), 0 0 120px rgba(255, 165, 0, 0.6)', '0 0 40px rgba(255, 215, 0, 0.6), 0 0 80px rgba(255, 165, 0, 0.4)']
            }} transition={{
              boxShadow: {
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} className="relative w-full md:w-auto px-12 py-5 rounded-full font-bold text-xl flex items-center justify-center gap-3 mx-auto overflow-hidden group" style={{
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 25%, #FFD700 50%, #FF8C00 75%, #FFD700 100%)',
              backgroundSize: '200% 200%',
              animation: 'gradient-shift 3s ease infinite',
              boxShadow: '0 10px 40px rgba(255, 215, 0, 0.5), inset 0 -5px 20px rgba(0, 0, 0, 0.2), inset 0 5px 20px rgba(255, 255, 255, 0.3)',
              transform: 'perspective(1000px) rotateX(5deg)',
              textShadow: '0 2px 10px rgba(0, 0, 0, 0.3), 0 0 20px rgba(255, 215, 0, 0.5)'
            }} data-id="element-286">
                {/* Animated gradient overlay */}
                <div className="absolute inset-0 opacity-50" style={{
                background: 'linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.8) 50%, transparent 70%)',
                backgroundSize: '200% 200%',
                animation: 'shimmer 2s infinite'
              }} data-id="element-287" />

                {/* Sparkle particles */}
                <motion.div className="absolute inset-0 pointer-events-none" animate={{
                opacity: [0.5, 1, 0.5]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-288">
                  {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute w-2 h-2 bg-white rounded-full" style={{
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)'
                }} animate={{
                  scale: [0, 1, 0],
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.2,
                  ease: 'easeInOut'
                }} data-id="element-289" />)}
                </motion.div>

                <motion.div animate={{
                rotate: [0, 10, -10, 0],
                scale: [1, 1.1, 1]
              }} transition={{
                duration: 1,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-290">
                  <ShoppingCart size={28} className="relative z-10 drop-shadow-lg" style={{
                  color: '#1a3a52'
                }} data-id="element-291" />
                </motion.div>
                <span className="relative z-10 text-[#1a3a52] font-extrabold uppercase tracking-wide" data-id="element-292">
                  Sí, quiero mi Edición Premium por solo $9.95
                </span>
              </motion.a>

              {/* Add keyframes for animations */}
              <style data-id="element-293">{`
                @keyframes gradient-shift {
                  0%, 100% { background-position: 0% 50%; }
                  50% { background-position: 100% 50%; }
                }
                @keyframes shimmer {
                  0% { background-position: -200% 0; }
                  100% { background-position: 200% 0; }
                }
              `}</style>

              <p className="mt-4 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-294">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-295" />
                Descarga inmediata · 6 bonos incluidos gratis
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}